import { useContext, useCallback } from 'react';
import _get from 'lodash/get';
import _find from 'lodash/find';
import { AjaxContext, AppContext, UserContext, formatListData } from 'commons-ui';
import { BULK_ACTIONS_RESOURCES, PAGE_NAMES, ACTION, ACL_RESOURCES } from 'constant';

const useService = () => {
	const { postData } = useContext(AjaxContext);
	const {
		app: { appName }
	} = useContext(AppContext);
	const { user } = useContext(UserContext);
	const { permissionsConfig } = useContext(UserContext);
	const getCsvDetails = useCallback(
		async ({ pageDetails, sortDetails, filterDetails }: { pageDetails: any; sortDetails: any; filterDetails: any }) => {
			const permission = _find(permissionsConfig, { actionName: ACTION.getBulkRefundCsvDetails });
			const result = await postData({
				endpoint: `/dashboard/getBulkRefundCsvDetails/${PAGE_NAMES.bulkActions}-${BULK_ACTIONS_RESOURCES.bulkRefund}-getBulkRefundCsvDetails`,
				queryParams: {
					appName
				},
				body: {
					page: pageDetails,
					filters: filterDetails,
					sortInfoArray: sortDetails
				},
				customHeaders: {
					isMasked: permission?.isMasked || false
				}
			});
			return {
				rowCount: _get(result, ['data', 'totalCount'], 0),
				data: formatListData(_get(result, ['data', 'csvDetails'], []))
			};
		},
		[]
	);

	const addCsvDetails = useCallback((wallet: any) => {
		const permission = _find(permissionsConfig, { actionName: ACTION.addBulkRefundCsvDetails });
		return postData({
			endpoint: `/dashboard/addBulkRefundCsvDetails/${PAGE_NAMES.bulkActions}-${BULK_ACTIONS_RESOURCES.bulkRefund}-addBulkRefundCsvDetails`,
			body: wallet,
			queryParams: {
				appName
			},
			customHeaders: {
				isMasked: permission?.isMasked || false
			}
		});
	}, []);

	const uploadCsvDetails = useCallback((formData: any) => {
		const permission = _find(permissionsConfig, { actionName: ACTION.uploadBulkRefundCsv });
		return postData({
			endpoint: `/dashboard/uploadBulkRefundCsv/${PAGE_NAMES.bulkActions}-${BULK_ACTIONS_RESOURCES.bulkRefund}-uploadBulkRefundCsv`,
			body: formData,
			customHeaders: { 'Content-Type': 'multipart/form-data', isMasked: permission?.isMasked || false },
			queryParams: {
				appName
			}
		});
	}, []);

	const executeBulkRefund = useCallback((walletId: string, description: string, gameName: string) => {
		const permission = _find(permissionsConfig, { actionName: ACTION.bulkRefundFromCsv });
		return postData({
			endpoint: `/dashboard/bulkRefundFromCsv/${PAGE_NAMES.bulkActions}-${BULK_ACTIONS_RESOURCES.bulkRefund}-bulkRefundFromCsv`,
			body: { _id: walletId, description, gameName, agentName: user?.userName },
			queryParams: {
				appName
			},
			customHeaders: {
				isMasked: permission?.isMasked || false
			}
		});
	}, []);

	const executeBulkRefundV2 = useCallback((walletId: string, description: string, gameName: string) => {
		const permission = _find(permissionsConfig, { actionName: ACTION.bulkRefundFromCsv });
		return postData({
			endpoint: `/v2/dashboard/bulkRefundFromCsv/${PAGE_NAMES.bulkActions}-${ACL_RESOURCES.bulkRefundV2}-bulkRefundFromCsvV2`,
			body: { _id: walletId, description, gameName, agentName: user?.userName, actionOwner: 'CRM', action: 'REFUND_USER' },
			queryParams: {
				appName
			},
			customHeaders: {
				isMasked: permission?.isMasked || false
			}
		});
	}, []);

	return {
		getCsvDetails,
		addCsvDetails,
		executeBulkRefund,
		executeBulkRefundV2,
		uploadCsvDetails
	};
};

export default useService;
